/* icon-wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import "./icon-wrapper.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { CSS_VAR_ICON, CSS_VAR_THEMED_ICON, CSS_VAR_TILE } from './constants';
var styles = {
  root: "_1e0c1o8l"
};
var sizeMap = {
  '20': "_4t3igktf",
  '24': "_4t3i1tcg",
  small: "_4t3i1tcg",
  medium: "_4t3izwfg",
  '32': "_4t3izwfg"
};
export function IconWrapper(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? '20' : _ref$size,
    label = _ref.label,
    svg = _ref.svg,
    customThemeSvg = _ref.customThemeSvg,
    userDefinedTestId = _ref.testId,
    _ref$appearance = _ref.appearance,
    appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance,
    iconColor = _ref.iconColor;
  var testId = userDefinedTestId && "".concat(userDefinedTestId, "--wrapper");
  var isCustomThemed = customThemeSvg && iconColor;
  return /*#__PURE__*/React.createElement("span", {
    "data-testid": testId,
    style: _defineProperty(_defineProperty(_defineProperty({}, CSS_VAR_ICON, appearance === 'legacy' ? 'white' : 'initial'), CSS_VAR_TILE, appearance === 'legacy' ? '#1868DB' : 'initial'), CSS_VAR_THEMED_ICON, iconColor || 'initial')
    // In some icons (such as the app switcher specific icons), the label is a consumer prop.
    // If the label is provided an empty string, we want to remove the element from the accessibility tree.
    ,
    "aria-label": label ? label : undefined,
    role: label ? 'img' : undefined,
    "aria-hidden": label === '' ? true : undefined
    // We are using dangerouslySetInnerHTML here to tell React not to track changes to the SVG elements.
    // This is because the SVG elements are static and will not change, so we get a little performance benefit by
    // bypassing React.
    ,
    dangerouslySetInnerHTML: {
      __html: isCustomThemed ? customThemeSvg : svg
    },
    className: ax([styles.root, sizeMap[size]])
  });
}